import { useEffect, useRef, useState } from "react";
import "./styles/index.scss";
import { Controller } from "react-hook-form";
import { default as ReactSelect } from "react-select";
import makeAnimated from "react-select/animated";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import it from "date-fns/locale/it"; // Italian
import { addDays, format } from "date-fns";
import { InfoTooltip, Tooltip } from "../Generic";
import useLabels from "../../hooks/useLabels";
import { Icon } from "../../components/Icon";

const ChatItem = ({ configs, users, note, index, length, getLabel }) => {
  const getChatTimestamp = (timestamp) => {
    const timestampDate = new Date(timestamp);
    const diff = Math.abs(new Date() - timestampDate);
    const minutes = Math.floor(diff / 1000 / 60);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    const weekAgo = new Date();
    weekAgo.setDate(yesterday.getDate() - 6);
    timestampDate.setHours(0, 0, 0, 0);

    if (minutes >= 0 && minutes <= 20 && index + 1 === length)
      return getLabel("justNow");
    else if ((minutes >= 0 && minutes <= 20) || (minutes > 20 && minutes < 60))
      return getLabel(minutes === 1 ? "minuteAgo" : "minutesAgo", {
        value: minutes || 2,
      });
    else if (minutes > 60 && minutes < 60 * 2)
      return getLabel("hourAgo", { value: Math.floor(minutes / 60) });
    else if (minutes > 60 * 2 && minutes < 60 * 8)
      return getLabel("hoursAgo", { value: Math.floor(minutes / 60) });
    else if (timestampDate.getTime() == yesterday.getTime())
      return getLabel("yesterday");
    else if (
      timestampDate.getTime() < yesterday.getTime() &&
      timestampDate.getTime() > weekAgo.getTime()
    )
      return getLabel("weekAgo");

    if (timestamp !== undefined)
      return format(timestampDate, configs.dateFormat);
    return "";
  };

  return (
    <div className="chat-item" key={`chat-item-${index}`}>
      <div className="chat-item_avatar">
        <div className="chat-item_avatar_container circle large">
          {/* <img alt={users?.find((u) => u?.id === note?.user_id)?.username || ''} src="https://avatars.githubusercontent.com/u/41473129?v=4" className="chat-avatar"></img> */}
          <Icon             icon={
              users?.find((u) => u?.id === note?.user_id)?.role_id == 2
                ? "fa-user-gear"
                : "fa-user"
            }
            style={{
              color: `${
                users?.find((u) => u?.id === note?.user_id)?.role_id == 2
                  ? "grey"
                  : ""
              }`,
            }}
            className="chat-avatar"
          />
        </div>
      </div>
      <div className="chat-item_body">
        <div className="chat-item_body_top">
          <div className="chat-item_body_top_title">
            {note?.from_username || ""}
          </div>
          <div className="chat-item_body_top_time">
            {getChatTimestamp(note?.timestamp)}
          </div>
          {/* <div className="chat-item_body_top_time">
            {note?.user_names?.map((u, index) => {
            return (<p>{u}</p>);
          })}
          </div> */}
        </div>
        <div className="chat-item_body_bottom">
          <div className="chat-item_body_bottom_title">
            {note?.message || ""}
          </div>
        </div>
      </div>
    </div>
  );
};

const ChatArea = ({
  label = "",
  register,
  users,
  name,
  tooltip,
  configs,
  operation,
  storeNote,
}) => {
  const [getLabel] = useLabels();
  const [isAddNewNoteClicked, setIsAddNewNoteClicked] = useState(false);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (
      !Array.isArray(operation?.chat_notes) ||
      operation?.chat_notes?.length === 0
    )
      return;

    const grouped = {};
    operation?.chat_notes.forEach((item) => {
      const key = `${item?.data?.operation_id}-${item?.message}`;

      if (!grouped[key]) {
        grouped[key] = {
          data: item.data,
          message: item.message,
          from_username:
            users?.find((u) => u?.id === item?.from_user_id)?.username || "",
          // user_id: item.from_user_id,
          user_ids: [item.user_id],
          user_names: [
            users?.find((u) => u?.id === item?.user_id)?.username || "",
          ],
          timestamp: item.timestamp,
          timestamps: [item.timestamp], // optional: keep track of when it was sent to each user
        };
      } else {
        const username =
          users?.find((u) => u?.id === item?.user_id)?.username || "";
        grouped[key].user_names.push(username);
        grouped[key].user_ids.push(item.user_id);
        grouped[key].timestamps.push(item.timestamp);
      }
    });

    const result = Object.values(grouped);
    if (Array.isArray(result) && result?.length > 0)
      setMessages(
        result?.sort((a, b) => new Date(a?.timestamp) - new Date(b?.timestamp))
      );
  }, [operation?.chat_notes]);

  const getRightLabel = () => {
    return label || name || "";
  };

  return (
    <div className={"chatarea_field"}>
      <h4>{getRightLabel()}</h4>
      {/* <label htmlFor={name}>
        {getRightLabel()}
        {<InfoTooltip html={tooltip} />}
      </label> */}
      <div className={"chat"}>
        {messages?.map((note, index) => {
          return (
            <ChatItem
              getLabel={getLabel}
              length={messages?.length}
              configs={configs}
              users={users}
              note={note}
              index={index}
              key={index}
            />
          );
        })}
        {messages?.length === 0 && (
          <h5 className="alert_no_info">{getLabel("noNotes")}</h5>
        )}
      </div>
      {operation?.completion_date === null && (
        <div className="note-container">
          {!isAddNewNoteClicked && (
            <>
              {messages?.length < 10 && (
                <button
                  onClick={() => setIsAddNewNoteClicked(true)}
                  className="new-note-button"
                >
                  {getLabel("addNote")}
                </button>
              )}
              {messages?.length >= 10 && (
                <div className="new-note-tooltip">
                  <Tooltip
                    variant={"info"}
                    html={getLabel("errorMaxNotes")}
                    place="right"
                    events={["hover"]}
                  >
                    <button className="new-note-button disabled">
                      {getLabel("addNote")}
                    </button>
                  </Tooltip>
                </div>
              )}
            </>
          )}
          {isAddNewNoteClicked && (
            <div className="new-note-container">
              <TextArea
                customClassName={"is_chat"}
                name="new_note"
                register={register}
                label={getLabel("lotNotes")}
                placeholder={getLabel("notesPlaceholder")}
                // error={error["new_note"]}
                tooltip={getLabel("notesTooltip")}
              />
              <div className="note-button-container">
                <button
                  onClick={() => {
                    storeNote();
                    setIsAddNewNoteClicked(false);
                  }}
                  className="store-note-button complete"
                >
                  {getLabel("storeNewNote")}
                </button>
                <button
                  onClick={() => setIsAddNewNoteClicked(false)}
                  className="store-note-button"
                >
                  {getLabel("cancelNewNote")}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const TextArea = ({
  label = "",
  register,
  name,
  placeholder,
  required,
  validate,
  isDisabled,
  onChange,
  onBlur,
  maxLength,
  onFocus,
  shouldUnregister,
  error,
  tooltip,
  isLabel = true,
  customClassName,
}) => {
  const getRightLabel = () => {
    return label || name || "";
  };
  return (
    <div
      className={`textarea_field ${customClassName ? customClassName : ""} ${
        error?.message ? "is_error" : ""
      }`}
    >
      {isLabel && (
        <label htmlFor={name}>
          {getRightLabel()}
          {<InfoTooltip html={tooltip} />}
        </label>
      )}
      <textarea
        id={name}
        placeholder={placeholder}
        {...register(name, {
          required,
          shouldUnregister,
          ...(validate && { validate: validate }),
          ...(isDisabled && { disabled: isDisabled }),
          ...(onChange && { onChange: onChange }),
          ...(onBlur && { onBlur: onBlur }),
          ...(maxLength && { maxLength: maxLength }),
        })}
      ></textarea>
      <div className="error_message">
        <span>{error?.message || ""}</span>
      </div>
    </div>
  );
};

const Input = ({
  label = "",
  register,
  name,
  type,
  placeholder = "",
  required,
  minLength,
  maxLength,
  max,
  min,
  regExpPattern,
  validate,
  isDisabled,
  onChange,
  onBlur,
  onFocus,
  shouldUnregister,
  error,
  isLabel = true,
  checked = false,
  isRequiredTooltip = true,
  step = 1,
  defaultValue = "",
  style,
  tooltip,
  accept,
  customClassName = "",
  isWarning = false,
  warningMessage = "",
  forceWarningChange = false,
  isOk = true,
  onKeyDown,
  showPasswordToggle = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const actualType = isPassword && showPassword ? "text" : type;

  const [isFocused, setIsFocused] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false);

  const getRightLabel = () => {
    return label || name || "";
  };

  const resolvedOnChange =
    isWarning && forceWarningChange // force handleChange instead of onChange when isWarning
      ? (e) => handleChange(e)
      : onChange;

  useEffect(() => {
    const handleWheel = () => {
      document.addEventListener("wheel", function (event) {
        if (
          document.activeElement.type === "number" &&
          document.activeElement.classList.contains("noscroll")
        ) {
          document.activeElement.blur();
        }
      });
    };
    handleWheel();

    window.addEventListener("wheel", handleWheel);
    return () => window.removeEventListener("wheel", handleWheel);
  }, []);

  const [val, setVal] = useState(defaultValue);
  const [ok, setOK] = useState();

  useEffect(() => {
    if (isOk) {
      const hasValue =
        (val?.toString()?.trim?.() ?? "").length > 0;

      const isWithinRange =
        (!min?.value || Number(val) >= Number(min.value)) &&
        (!max?.value || Number(val) <= Number(max.value));

      setOK(
        hasValue &&
        isWithinRange &&
        !error?.message // solo errori BLOCCANTI
      );
    }
  }, [val, error, min, max]);


  const handleChange = (e) => {
    // if (isWarning) {
    //   setWarning((error?.message && error?.type && (error.type === 'min' || error.type === 'max') && type === 'number' && Number(e.target.value) > 0));
    //   setOK((!error?.message || error?.message === undefined) && (e.target.value?.trim?.() ?? "").toString()?.length > 0 && (!min?.value || e.target.value >= Number(min?.value) && (!max?.value || e.target.value <= Number(max?.value))));
    // }

    if (e.target?.value) {
      setVal(e.target.value);
    }
    if (onChange) {
      onChange(e);
    }
  };

  const handleBlur = (e) => {
    setIsBlurred(true);
    if (onBlur) {
      onBlur(e);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const { ref, ...restRegister } = register(name, {
    required,
    shouldUnregister,
    ...(maxLength && { maxLength: maxLength }),
    ...(min && { min: min }),
    ...(max && { max: max }),
    ...(regExpPattern && { pattern: regExpPattern }),
    ...(validate && { validate: validate }),
    // ...(isDisabled && { disabled: isDisabled }),
    // ...(onChange && { onChange: onChange }),
    // ...(onBlur && { onBlur: onBlur }),
    ...(accept && { accept: accept }),
    ...(resolvedOnChange && { onChange: resolvedOnChange }),

    ...(onBlur && { onBlur: isWarning ? (e) => handleBlur(e) : onBlur, }),
    // ...(onFocus && { onFocus: (e) => setIsFocused(prev => !prev)}),
  });

  return (
    <div
      className={`input_field
        ${error?.message ? "is_error" : ""}
        ${!error?.message && isWarning ? "is_warning" : ""}
        ${isOk && ok ? "is_ok" : ""}
        ${
          type === "checkbox"
            ? `is_checkbox ${
                isLabel && customClassName !== "tank_form" ? "is_label" : ""
              }`
            : type === "number" && customClassName === "quantity"
            ? "is_number"
            : ["small", "is_login"].includes(customClassName) ? customClassName : ""
        }
      `}
    >
      {isLabel && (
        <label
          htmlFor={name}
          className={`${type === "checkbox" ? "is_checkbox" : ""} ${
            customClassName === "winemaking" ? customClassName : ""
          } ${required?.length > 0 && isRequiredTooltip ? "required" : ""}`}
        >
          {getRightLabel()}
          {<InfoTooltip html={tooltip} />}
        </label>
      )}
      <div 
        className={`input_with_button ${!error?.message && isWarning ? "is_warning" : ""}`}>
        <input
          ref={ref}
          // ref={(e) => {
          //   ref(e);         // attach RHF ref
          //   if (e) e.scrollIntoView({ behavior: "smooth", block: "center" });
          // }}
          className={`${
            type === "range" ? "is_slider" : customClassName
          } noscroll ${isDisabled ? "disabled" : ""}`}
          id={name}
          type={actualType}
          placeholder={placeholder}
          // checked={checked}
          // defaultValue={val}
          {...(type === "checkbox" ? {} : { defaultValue: val })}
          style={style}
          step={type === "number" && step ? step : 1}
          // min={min}
          // max={max}
          disabled={isDisabled}
          {...restRegister}
          // {...register(name, {
          //   required,
          //   shouldUnregister,
          //   ...(minLength && { minLength: minLength }),
          //   ...(maxLength && { maxLength: maxLength }),
          //   ...(min && { min: min }),
          //   ...(max && { max: max }),
          //   ...(regExpPattern && { pattern: regExpPattern }),
          //   ...(validate && { validate: validate }),
          //   ...(isDisabled && { disabled: isDisabled }),
          //   // ...(onChange && { onChange: onChange }),
          //   // ...(onBlur && { onBlur: onBlur }),
          //   ...(accept && { accept: accept }),
          //   ...(onChange && !isWarning && { onChange: onChange }),
          //   ...(onChange && isWarning && { onChange: (e) => handleChange(e)}),
          //   ...(onBlur && !isWarning && { onBlur: onBlur }),
          //   ...(onBlur && isWarning && { onBlur: (e) => handleBlur(e)}),
          //   // ...(onFocus && { onFocus: (e) => setIsFocused(prev => !prev)}),
          // })}
          onKeyDown={(e) => {
            if (onKeyDown) onKeyDown(e);
          }}
        />
        {isPassword && showPasswordToggle && (
          <button
            type="button"
            className="toggle_password_btn"
            onClick={togglePasswordVisibility}
            tabIndex={-1} // skip tab focus if needed
          >
            {showPassword ? (
              <Icon icon="fa-eye-slash" />
            ) : (
              <Icon icon="fa-eye" />
            )}
          </button>
        )}
      </div>
      <div className="error_message">
        {/* HARD ERROR (RHF) */}
        {error?.message && (
          <span className="is_error">
            {error.message}
          </span>
        )}

        {/* WARNING (NON blocking) */}
        {!error?.message && isWarning && warningMessage && (
          <span className="is_warning">
            {warningMessage}
          </span>
        )}
      </div>

    </div>
  );
};

const Input2 = ({
  label = "",
  register,
  name,
  type,
  placeholder = "",
  required,
  minLength,
  maxLength,
  max,
  min,
  regExpPattern,
  validate,
  isDisabled,
  onChange,
  onBlur,
  onFocus,
  shouldUnregister,
  error,
  isLabel = true,
  checked = false,
  isRequiredTooltip = true,
  step = 1,
  defaultValue = "",
  style,
  tooltip,
  accept,
  customClassName = "",
  isWarning = false,
  forceWarningChange = false,
  isOk = true,
  onKeyDown,
  showPasswordToggle = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const actualType = isPassword && showPassword ? "text" : type;

  const [isFocused, setIsFocused] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false);

  const getRightLabel = () => {
    return label || name || "";
  };

  const resolvedOnChange =
    isWarning && forceWarningChange // force handleChange instead of onChange when isWarning
      ? (e) => handleChange(e)
      : onChange;

  useEffect(() => {
    const handleWheel = () => {
      document.addEventListener("wheel", function (event) {
        if (
          document.activeElement.type === "number" &&
          document.activeElement.classList.contains("noscroll")
        ) {
          document.activeElement.blur();
        }
      });
    };
    handleWheel();

    window.addEventListener("wheel", handleWheel);
    return () => window.removeEventListener("wheel", handleWheel);
  }, []);

  const [val, setVal] = useState(defaultValue);
  const [warning, setWarning] = useState();
  const [ok, setOK] = useState();

  const warningCondition =
    isWarning &&
    error?.message &&
    error?.type &&
    (error.type === "min" || error.type === "max" || error.type === "validate") &&
    type === "number" &&
    Number(val) > 0;

  useEffect(() => {
    setWarning(warningCondition);
    setOK(
      (!error?.message || error?.message === undefined) &&
        (val?.trim?.() ?? "").toString()?.length > 0 &&
        (!min?.value ||
          (val >= Number(min?.value) &&
            (!max?.value || val <= Number(max?.value))))
    );
  }, [val, warningCondition]);

  const handleChange = (e) => {
    // if (isWarning) {
    //   setWarning((error?.message && error?.type && (error.type === 'min' || error.type === 'max') && type === 'number' && Number(e.target.value) > 0));
    //   setOK((!error?.message || error?.message === undefined) && (e.target.value?.trim?.() ?? "").toString()?.length > 0 && (!min?.value || e.target.value >= Number(min?.value) && (!max?.value || e.target.value <= Number(max?.value))));
    // }

    if (e.target?.value) {
      setVal(e.target.value);
    }
    if (onChange) {
      onChange(e);
    }
  };

  const handleBlur = (e) => {
    setIsBlurred(true);
    if (onBlur) {
      onBlur(e);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const { ref, ...restRegister } = register(name, {
    required,
    shouldUnregister,
    ...(maxLength && { maxLength: maxLength }),
    ...(min && { min: min }),
    ...(max && { max: max }),
    ...(regExpPattern && { pattern: regExpPattern }),
    ...(validate && { validate: validate }),
    // ...(isDisabled && { disabled: isDisabled }),
    // ...(onChange && { onChange: onChange }),
    // ...(onBlur && { onBlur: onBlur }),
    ...(accept && { accept: accept }),
    ...(resolvedOnChange && { onChange: resolvedOnChange }),

    ...(onBlur && { onBlur: isWarning ? (e) => handleBlur(e) : onBlur, }),
    // ...(onFocus && { onFocus: (e) => setIsFocused(prev => !prev)}),
  });

  return (
    <div
      className={`input_field 
        ${error?.message ? "is_error" : ""} ${
        warningCondition ? "is_warning" : ""
      }
        ${isOk && ok ? "is_ok" : ""}
        ${
          type === "checkbox"
            ? `is_checkbox ${
                isLabel && customClassName !== "tank_form" ? "is_label" : ""
              }`
            : type === "number" && customClassName === "quantity"
            ? "is_number"
            : ""
        }`}
    >
      {isLabel && (
        <label
          htmlFor={name}
          className={`${type === "checkbox" ? "is_checkbox" : ""} ${
            customClassName === "winemaking" ? customClassName : ""
          } ${required?.length > 0 && isRequiredTooltip ? "required" : ""}`}
        >
          {getRightLabel()}
          {<InfoTooltip html={tooltip} />}
        </label>
      )}
      <div
        className={`input_with_button ${warningCondition ? "is_warning" : ""}`}
      >
        <input
          ref={ref}
          // ref={(e) => {
          //   ref(e);         // attach RHF ref
          //   if (e) e.scrollIntoView({ behavior: "smooth", block: "center" });
          // }}
          className={`${
            type === "range" ? "is_slider" : customClassName
          } noscroll ${isDisabled ? "disabled" : ""}`}
          id={name}
          type={actualType}
          placeholder={placeholder}
          // checked={checked}
          // defaultValue={val}
          {...(type === "checkbox" ? {} : { defaultValue: val })}
          style={style}
          step={type === "number" && step ? step : 1}
          // min={min}
          // max={max}
          disabled={isDisabled}
          {...restRegister}
          // {...register(name, {
          //   required,
          //   shouldUnregister,
          //   ...(minLength && { minLength: minLength }),
          //   ...(maxLength && { maxLength: maxLength }),
          //   ...(min && { min: min }),
          //   ...(max && { max: max }),
          //   ...(regExpPattern && { pattern: regExpPattern }),
          //   ...(validate && { validate: validate }),
          //   ...(isDisabled && { disabled: isDisabled }),
          //   // ...(onChange && { onChange: onChange }),
          //   // ...(onBlur && { onBlur: onBlur }),
          //   ...(accept && { accept: accept }),
          //   ...(onChange && !isWarning && { onChange: onChange }),
          //   ...(onChange && isWarning && { onChange: (e) => handleChange(e)}),
          //   ...(onBlur && !isWarning && { onBlur: onBlur }),
          //   ...(onBlur && isWarning && { onBlur: (e) => handleBlur(e)}),
          //   // ...(onFocus && { onFocus: (e) => setIsFocused(prev => !prev)}),
          // })}
          onKeyDown={(e) => {
            if (onKeyDown) onKeyDown(e);
          }}
        />
        {isPassword && showPasswordToggle && (
          <button
            type="button"
            className="toggle_password_btn"
            onClick={togglePasswordVisibility}
            tabIndex={-1} // skip tab focus if needed
          >
            {showPassword ? (
              <Icon icon="fa-eye-slash" />
            ) : (
              <Icon icon="fa-eye" />
            )}
          </button>
        )}
      </div>
      <div
        className={`error_message ${
          error?.message &&
          warningCondition &&
          error?.type &&
          (error.type === "min" || error.type === "max" || error.type === "validate") &&
          type === "number" &&
          Number(val) > 0
            ? "is_warning"
            : ""
        }`}
      >
        <span>{error?.message || error?.name?.message || ""}</span>
      </div>
    </div>
  );
};

const Submit = ({ label, customClassName }) => {
  return (
    <div className={`submit_field ${customClassName ? customClassName : ""}`}>
      <input type="submit" value={label} />
    </div>
  );
};

const Switch = ({
  leftOption,
  rightOption,
  fixed = false,
  disabled = false,
  toggleHandler,
  status,
  negative = false,
}) => {
  return (
    <div
      onClick={disabled ? null : toggleHandler}
      className={`switch_field ${disabled && !fixed ? "disabled" : ""} ${
        fixed ? "fixed" : ""
      }`}
    >
      <div
        className={`switch_field_left ${!status ? "active" : ""} ${
          negative ? "negative" : ""
        }`}
      >
        {leftOption.label}
      </div>
      <label className="switch_field_switch">
        <input
          className={`${disabled ? "disabled" : ""}`}
          disabled={disabled}
          type="checkbox"
          checked={status}
          onClick={(e) => e.stopPropagation()}
        ></input>
        <span
          className={`switch_field_slider ${
            disabled && !fixed ? "disabled" : ""
          } ${fixed ? "fixed" : ""} ${negative ? "negative" : ""}`}
        ></span>
      </label>
      <div
        className={`switch_field_right ${
          disabled && !fixed ? "disabled" : ""
        } ${fixed ? "fixed" : ""} ${status ? "active" : ""}`}
      >
        {rightOption.label}
      </div>
    </div>
  );
};

const Switch3 = ({
  options, // [{ label, value }]
  value,   // domain value (0 | 1 | 2)
  onChange,
  disabled = false,
  fixed = false,
  negative = false,
}) => {
  const activeIndex = options.findIndex(
    (opt) => opt.value === value
  );
  const handleClick = (index) => {
    if (disabled || fixed) return;
    onChange(options[index].value);
  };

  return (
    <div className="switch_3_wrapper">
      <div
        className={`switch_field switch_3 ${
          disabled && !fixed ? "disabled" : ""
        } ${fixed ? "fixed" : ""}`}
        data-value={activeIndex}
      >
        <div className="switch_field_options_wrapper">
          {options.map((opt, i) => (
            <div
              key={opt.value}
              onClick={() => handleClick(i)}
              className={`switch_field_option ${
                i === activeIndex ? "active" : ""
              } ${negative ? "negative" : ""}`}
            >
              {opt.label}
            </div>
          ))}
        </div>
  
        <div className="switch_field_switch">
          <span
            className={`switch_field_slider ${
              disabled && !fixed ? "disabled" : ""
            } ${fixed ? "fixed" : ""}`}
          />

          <div className="switch_field_hits">
            {options.map((_, i) => (
              <div
                key={i}
                className="switch_field_hit"
                onClick={() => handleClick(i)}
              />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

const Label = ({
  label,
  children,
  width,
  height,
  tooltip,
  customClassName,
}) => (
  <div
    className="label_field"
    style={{
      ...(width && { width: `${width}px` }),
      ...(height && { height: `${height}px` }),
    }}
  >
    <label className="label_field_label">
      {label}
      <InfoTooltip html={tooltip} />
    </label>
    <div className={`label_field_value ${customClassName}`}>{children}</div>
  </div>
);

const Select = ({
  control,
  defaultValue,
  label,
  name,
  required,
  pattern,
  placeholder,
  options,
  isTable = false,
  isDisabled = false,
  isSearchable = false,
  isCreatable = false,
  isLabel = true,
  error,
  tooltip,
  customClassName = "",
  onCreateOption = null,
  onTableChange = () => {
    return null;
  },
}) => {
  const getError = () => {
    if (!error) return "";

    const result = [name].map((s) =>
      s
        .split(".")
        .filter((t) => t !== "")
        .reduce((prev, cur) => prev && prev[cur], error)
    )[0];
    // Evita che un array di errori venga considerato errore
    if (Array.isArray(result)) return "";

    return result?.message || "";
  };

  return (
    <div
      className={`select_field_controlled_container ${
        customClassName ? customClassName : ""
      } ${isTable ? "is_table" : ""} ${error ? "is_error" : ""}`}
    >
      {!isTable && isLabel && (
        <label htmlFor={name} className={`${required ? "required" : ""}`}>
          {label}
          {<InfoTooltip html={tooltip} />}
        </label>
      )}
      <Controller
        control={control}
        name={name}
        rules={{
          required: required,
          pattern: pattern,
          validate: (val) => val?.value != null || required,
        }}
        defaultValue={defaultValue ?? ""}
        render={({ field, fieldState: { error } }) => (
          <SelectTemplate
            placeholder={placeholder}
            onChange={(value) => {
              field.onChange(value);
              onTableChange(value);
            }}
            value={field.value}
            // options={options?.filter(o => o?.value !== field?.value?.value)}
            options={options?.filter((o) => o?.label !== field?.value?.label)}
            isTable={isTable}
            error={error}
            isDisabled={isDisabled}
            isSearchable={isSearchable}
            isCreatable={isCreatable}
            onCreateOption={onCreateOption}
          />
        )}
      />
      {getError() && (
        <div className="error_message">
          <span>{getError()}</span>
        </div>
      )}
    </div>
  );
};

const SelectTemplate = ({
  value,
  onChange,
  options = [],
  placeholder,
  isTable = false,
  isDisabled = false,
  isSearchable = false,
  isCreatable = false,
  onCreateOption = null,
  error,
}) => {
  const [getLabel] = useLabels();
  const [val, setVal] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (!value) {
      setVal(null);
    }
  }, [value]);

  const handleClickOutside = (event) => {
    if (wrapperRef && !wrapperRef?.current?.contains(event.target)) {
      openAndAnimate(false);
    }
  };

  const openAndAnimate = (value) => {
    if (value) {
      setIsOpen(value);
      setTimeout(() => {
        setIsAnimated(value);
      }, 10);
    } else {
      setIsAnimated(value);
      setIsFocused(false);
      setTimeout(() => {
        setIsOpen(value);
      }, 10);
    }
  };

  const changeValue = (value) => {
    onChange(value);
    setVal(value);
    openAndAnimate(false);
  };

  const noop = () => {
    return null;
  };
  
  return (
    <div className="select_field_wrapper" ref={wrapperRef}>
      {!isSearchable && (
        <div
          disabled={!options?.length || isDisabled}
          className={`select_field_wrapper_container ${
            isOpen ? "opened" : ""
          } ${error ? "is_error" : ""} ${isTable ? "is_table" : ""} ${
            isDisabled ? "disabled" : ""
          } ${
            (!value || !value.value) && !value?.label && (!val || !val.value)
              ? "gray_filtered"
              : ""
          }`}
          onClick={(e) => {
            if (options?.length && !isDisabled) {
              openAndAnimate(!isOpen);
            } else {
              noop();
            }
            e.stopPropagation();
          }}
        >
          {!isTable && (value?.label || placeholder)}
          {isTable && placeholder}
        </div>
      )}

      {isSearchable && (
        <input
          // disabled={!options?.length}
          className={`select_field_wrapper_container ${
            isOpen ? "opened" : ""
          } ${error ? "is_error" : ""} ${isTable ? "is_table" : ""} ${
            isDisabled ? "disabled" : ""
          } ${
            isOpen ||
            ((!value || !value.value) && !value?.label && (!val || !val.value))
              ? "gray_filtered"
              : ""
          }`}
          onClick={(e) => {
            // if ((options?.length || (isCreatable && !isOpen)) && !isDisabled) {
            if (options?.length && !isDisabled) {
              openAndAnimate(!isOpen);
            } else {
              noop();
            }
            e.stopPropagation();
          }}
          onChange={(e) => {
            setVal({
              label: e.target.value,
              value: e.target.value?.toLowerCase?.()?.trim(),
            });
            e.stopPropagation();
          }}
          onBlur={() => setIsFocused(false)}
          onFocus={(e) => {
            onChange(value);
            setVal({ label: "", value: "" });
            setIsFocused(true);
            e.stopPropagation();
          }}
          onKeyDown={(e) => {
            if (isCreatable && e.key === "Enter") {
              e.preventDefault();
              if (
                isCreatable &&
                val?.label &&
                (options?.length === 0 ||
                  !options?.some(
                    (o) =>
                      (o?.label || o?.name)?.toLowerCase?.() ===
                      val?.label?.toLowerCase()
                  ))
              ) {
                const newOption = {
                  label: val?.label,
                  value: val?.label?.trim(),
                  is_new: true,
                };

                if (onCreateOption) {
                  onCreateOption(newOption);
                }
                onChange(newOption);
                setVal(newOption);
                openAndAnimate(false);
              }
            }
          }}
          value={isOpen ? val?.label : value?.label}
          placeholder={!isTable ? placeholder : placeholder}
        />
      )}
      {(isOpen || (isCreatable && isFocused && val?.label)) && (
        <div className="select_field_options_wrapper">
          {(isSearchable
            ? options?.filter(
                (item) =>
                  !val?.label ||
                  (item?.name || item?.label)
                    ?.toLowerCase?.()
                    .includes(val?.value)
              )
            : options
          )?.map?.((option, index) => {
            return (
              <div
                key={index}
                className={`select_field_options_option ${
                  option?.className || ""
                }  ${option?.is_disabled ? "disabled" : ""}`}
                onClick={() => {
                  if (option?.is_disabled) return;
                  changeValue(option);
                }}
              >
                <span className={`${option?.is_disabled ? "disabled" : ""}`}>
                  {option?.name || option.label}
                </span>
                {option?.icon && (
                  <span className="option_icon">
                    <Icon                       icon={option?.icon}
                      style={{
                        color: option?.icon_color || "grey",
                      }}
                      size="xs"
                    />
                  </span>
                )}
                {option?.is_sanitized === true && (
                  <span className="option_icon">
                    <Icon
                      icon={"fa-circle"}
                      style={{
                        color: "rgba(18, 243, 79, 0.5)",
                        borderRadius: "50%",
                        border: "1px solid rgb(19 112 44)",
                      }}
                      size="xxs"
                    />
                  </span>
                )}
                {/* {option?.tag?.value && <p className="option_tag">{option?.tag?.value}</p>} */}
              </div>
            );
          })}
          {isCreatable &&
            val?.label &&
            (options?.length === 0 ||
              !options?.some(
                (o) =>
                  (o?.label || o?.name)?.toLowerCase?.() ===
                  val.label.toLowerCase()
              )) && (
              <div
                className="select_field_options_option creatable_option"
                onClick={() => {
                  const newOption = {
                    label: val?.label,
                    value: val?.label?.trim(),
                    is_new: true,
                  };

                  if (onCreateOption) {
                    onCreateOption(newOption);
                  }
                  onChange(newOption);
                  setVal(newOption);
                  openAndAnimate(false);
                }}
              >
                <span>{`${getLabel("createNewOption")} "${val?.label}"`}</span>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

const DatePicker = ({
  name,
  label,
  required,
  pattern,
  validate,
  control,
  defaultValue,
  placeholder,
  error,
  dateFormat,
  datePickerData = {},
  isTime = false,
  isLabel = true,
  onChange = () => {},
  getLocaleObject = () => it,
}) => {
  const localeObj = getLocaleObject();
  registerLocale("it", localeObj);

  return (
    <div
      className={`datepicker_field_controlled_container  ${
        error?.message ? "is_error" : ""
      }`}
    >
      {isLabel && <label htmlFor={name}>{label}</label>}
      <Controller
        control={control}
        name={name}
        rules={{ required: required, pattern: pattern, validate: validate }}
        defaultValue={defaultValue ? new Date(defaultValue) : new Date()}
        render={({ field }) => (
          <>
            {!isTime && (
              <ReactDatePicker
                selected={field?.value ? new Date(field?.value) : null}
                onChange={(value) => {
                  field.onChange(value);
                  onChange(value);
                }}
                startDate={addDays(new Date(), 1)}
                // minDate={addDays(new Date(), 1)}
                className={"input_error"}
                minDate={new Date()}
                locale="it"
                dateFormat={dateFormat || null}
                placeholderText={placeholder}
                autoFocus={false}
                preventOpenOnFocus={true}
                {...datePickerData}
              />
            )}
            {isTime && (
              <ReactDatePicker
                selected={field?.value ? new Date(field?.value) : null}
                onChange={(value) => {
                  field.onChange(value);
                  onChange(value);
                }}
                dateFormat={dateFormat || null}
                minDate={new Date()}
                locale="it"
                selectsStart
                // startDate={dates.startDate}
                // endDate={dates.endDate}
                showTimeInput
                timeFormat="HH:mm"
                timeIntervals={5}
                timeCaption={'getLabel("analysisExamStartTime")'}
                placeholderText={placeholder}
                autoFocus={false}
                preventOpenOnFocus={true}
                // timeCaption={getLabel("analysisExamStartTime")}
                {...datePickerData}
              />
            )}
            {isTime && (!field?.value || field?.value === null) && (
              <div className="error_message">
                <span>{error?.message}</span>
              </div>
            )}
          </>
        )}
      />
      {!isTime && (
        <div className="error_message">
          <span>{error?.message}</span>
        </div>
      )}
    </div>
  );
};

const MultipleSelect = ({
  error,
  control,
  defaultValue,
  label,
  name,
  required,
  pattern,
  placeholder,
  closeMenuOnSelect,
  options,
  tooltip,
  isGrouped = false,
  isMulti = true,
  isLabel = true,
  onTableChange = null,
}) => {
  const [selectedOptions, setSelectedOptions] = useState();
  const animatedComponents = makeAnimated();

  const getError = () => {
    if (!error) return "";

    // Se error è già un FieldError diretto (ha message), usalo subito
    // Questo copre il caso error={errors["campo"]}
    if (error.message !== undefined) return error.message;

    // Altrimenti naviga l'oggetto errors via name (path nested es. "a.b.c")
    // Questo copre il caso error={errors}
    const result = name
      .split(".")
      .filter((t) => t !== "")
      .reduce((prev, cur) => prev && prev[cur], error);

    // Evita che un array di errori venga considerato errore
    if (Array.isArray(result)) return "";

    return result?.message || "";
  };

  const hasError = !!getError();
  const errorBorderColor = "#c0392b"; // variabile RedError del progetto

  const colorStyles = {
    className: "multiple_select_field",
    control: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        minHeight: "47px",
        // padding: "8px 12px",
        borderRadius: "8px",
        border: hasError
          ? `2px solid ${errorBorderColor}`
          : "2px solid rgba(33, 37, 31, 0.32)",
        boxShadow: "none",
        "&:hover": {
          border: hasError
            ? `2px solid ${errorBorderColor}`
            : "2px solid rgba(33, 37, 31, 0.32)",
        },
      };
    },
    multiValue: (styles) => ({
      ...styles,
      display: "flex",
      alignItems: "center",
      backgroundColor: "rgba(33, 37, 31, 0.12)",
      borderRadius: "3px",
      gap: "4px",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontSize: "16px",
      fontWeight: 400,
      color: "#212520",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      color: "#64242e",
      // padding: "0 2px",
      marginLeft: "4px",
      ":hover": {
        color: "white",
        backgroundColor: "#64242e",
        borderRadius: "2px",
      },
    }),
    valueContainer: (styles) => ({
      ...styles,
      overflow: "visible",
      whiteSpace: "normal",
      width: "100%",
      flexWrap: "wrap",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: "rgba(198, 227, 225, 0.2)",
        // cursor: isDisabled ? 'not-allowed' : 'default',
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? "rgba(185, 184, 180, 0.5)"
          : isFocused
          ? "rgba(185, 184, 180, 0.35)"
          : undefined,
        color: isDisabled ? "#64242e" : "black",
        ":active": {
          ...styles[":active"],
        },
      };
    },
  };

  function handleSelect(data) {
    setSelectedOptions(data);
  }

  return (
    <div
      className={`multiple_select_field_controlled_container ${
        getError() ? "is_error" : ""
      }`}
      // style={{ zIndex: 11 }}
    >
      {isLabel && (
        <label htmlFor={name} className={required ? "required" : ""}>
          {label}
          {<InfoTooltip html={tooltip} />}
        </label>
      )}
      <Controller
        control={control}
        name={name}
        rules={{ required: required, pattern: pattern }}
        defaultValue={defaultValue || ""}
        render={({ field }) => (
          <ReactSelect
            components={animatedComponents}
            classNamePrefix="multiple_select_field"
            options={options}
            placeholder={placeholder}
            // onChange={(value) => field.onChange(value)}
            onChange={(value, action) => {
              field.onChange(value);
              if (onTableChange) {
                // used in ProtocolForm to reset the Select after the selection
                onTableChange(value);

                if (action.action === "select-option" && !isMulti) {
                  // Reset only for single select
                  setTimeout(() => {
                    field.onChange(null);
                  }, 0);
                }
              }
            }}
            value={field.value}
            // value={selectedOptions}
            // onChange={handleSelect}
            isSearchable={true}
            isGrouped={isGrouped}
            styles={colorStyles}
            closeMenuOnSelect={closeMenuOnSelect}
            isMulti={isMulti ? isMulti : false}
            // formatGroupLabel={
            //   isGrouped
            //     ? (data) => (
            //         <div style={{ display: "flex", justifyContent: "space-between" }}>
            //           <span>{data.label}</span>
            //           <span style={{ opacity: 0.5 }}>{data.options.length}</span>
            //         </div>
            //       )
            //     : undefined
            // }
          />
        )}
      />
      {getError() && (
        <div className="error_message">
          <span>{getError()}</span>
        </div>
      )}
    </div>
  );
};

const Slider = ({
  label = "",
  register,
  name,
  type,
  placeholder = "",
  required,
  minLength,
  maxLength,
  max,
  min,
  regExpPattern,
  validate,
  isDisabled,
  onChange,
  onBlur,
  onFocus,
  shouldUnregister,
  error,
  isLabel = true,
  checked = false,
  isText = false,
  defaultValue = "",
  tooltip,
  additional = {},
}) => {
  const MAX = 100;
  const [value, setValue] = useState(0);

  const getBackgroundSize = (isFixed = false) => {
    return isFixed
      ? {
          display: "block",
          width: `${defaultValue || 0}%`,
        }
      : {
          backgroundSize: `${((value || defaultValue) * 100) / MAX}% 100%`,
          display: "block",
          marginTop: "15px",
          marginBottom: "5px",
        };
  };

  return (
    <div className={"slider"}>
      {register && (
        <Input
          name={name}
          register={register}
          type={"range"}
          error={error}
          required={required}
          max={max}
          min={min}
          label={label}
          onChange={(e) => setValue(e.target.value)}
          style={getBackgroundSize()}
          tooltip={tooltip}
        />
      )}
      {!register && (
        <div className="is-flex">
          <div
            className={`no-slide ${
              additional?.is_sanitized ? "sanitized" : ""
            }`}
          >
            <div
              className={`progress ${additional?.color || "red"}`}
              style={getBackgroundSize(true)}
            ></div>
          </div>
        </div>
      )}
      {isText && (
        <p className="slider_text">{`${value || defaultValue}% ${
          !register ? ` (${additional?.quantity}L)` : ""
        }`}</p>
      )}
    </div>
  );
};

export {
  Input,
  Submit,
  Switch,
  Switch3,
  Label,
  Select,
  TextArea,
  ChatArea,
  MultipleSelect,
  DatePicker,
  Slider,
};
